export default __webpack_public_path__ + "static/media/no-file-found.46181480.png";